import { apiClient } from '@/lib/api-client';

// The master catalogue's view of one product at every outlet
// (docs/master-catalogue-plan.md §7, §17). Same API as the admin Stores matrix.

/** One outlet of the business for a master (GET /product-masters/:id `stores`). */
export interface MasterOutlet {
  location_id: string;
  location_name: string;
  location_code: string | null;
  /** The outlet's row for this product; null when it never carried it. */
  product_id: string | null;
  enabled: boolean;
  /** A restaurant outlet's 86 state: false while the dish is sold out there. */
  is_available?: boolean | null;
}

export interface MasterWithOutlets {
  id: string;
  name: string;
  stores: MasterOutlet[];
}

export const productMasterService = {
  /** The master catalogue entry a store row lists (null when it is not linked yet). */
  async masterIdOf(productId: string): Promise<string | null> {
    const row = await apiClient<{ master_id?: string | null }>(`/products/${productId}`);
    return row.master_id ?? null;
  },

  getById(masterId: string) {
    return apiClient<MasterWithOutlets>(`/product-masters/${masterId}`);
  },

  /** Owner at any outlet, a Manager at assigned outlets only (the API checks). */
  setLocations(masterId: string, change: { enable?: string[]; disable?: string[] }) {
    return apiClient<unknown>(`/product-masters/${masterId}/locations`, {
      method: 'POST',
      body: { enable: change.enable ?? [], disable: change.disable ?? [] },
    });
  },

  /** 86 a dish at one outlet (its row), or bring it back. Other outlets are untouched. */
  setMenuAvailability(productId: string, available: boolean) {
    return apiClient<unknown>(`/menu/items/${productId}/availability`, {
      method: 'PUT',
      body: { available },
    });
  },
};
